<template>
    <div class="text-center">
        <h1>404</h1>
        <p>Nothing to see here</p>
    </div>
</template>
<script>
    export default {
        name: 'notFound'
    };
</script>